module.exports = __webpack_public_path__ + "static/media/top_erweima.c4e6cfa1.png";